export let distributorUrl = function (dealTier) {
  if (dealTier.has_storefront) {
    return `/storefront/${dealTier.distributor_id}`;
  } else {
    return `/?distributors=${dealTier.distributor_id}`;
  }
};
export default { distributorUrl };
